module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('intro'), _vm._v(" "), _c('offer'), _vm._v(" "), _c('plasma')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-187877de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/landing/Landing.vue
// module id = 41
// module chunks = 0